import {
    ScenarioRunExactCallCount,
    ScenarioRunExactCalls,
} from '../../../api/api';

/** The calls by kind, most first, such as `GET SalesEntries 4, XML MatchSets 1`; empty for none. */
export const byKind = (count?: ScenarioRunExactCallCount): string =>
    Object.entries(count?.byCall ?? {})
        .sort(([kindA, a], [kindB, b]) => b - a || kindA.localeCompare(kindB))
        .map(([kind, calls]) => `${kind} ${calls}`)
        .join(', ');

const counted = (count?: ScenarioRunExactCallCount) => {
    if (!count) return 'not counted';

    const kinds = byKind(count);

    return kinds ? `${count.total ?? 0} (${kinds})` : `${count.total ?? 0}`;
};

/** The short label of a scenario's Exact calls, connector + runner, such as `Exact 14 + 9`; undefined when neither counted. */
export const scenarioCallsLabel = (
    connector?: ScenarioRunExactCallCount,
    runner?: ScenarioRunExactCallCount
) =>
    connector || runner
        ? `Exact ${connector ? connector.total ?? 0 : '?'} + ${
              runner ? runner.total ?? 0 : '?'
          }`
        : undefined;

/** The breakdown behind a scenario's label, for its tooltip. */
export const scenarioCallsTitle = (
    connector?: ScenarioRunExactCallCount,
    runner?: ScenarioRunExactCallCount
) =>
    `Exact calls - connector: ${counted(connector)}; runner: ${counted(
        runner
    )}`;

/** The run's label, such as `23 Exact calls (connector 14, runner 9)`; undefined when the run counted nothing. */
export const runCallsLabel = (calls?: ScenarioRunExactCalls) =>
    calls
        ? `${calls.total ?? 0} Exact calls (connector ${
              calls.connector?.total ?? 0
          }, runner ${calls.runner?.total ?? 0})`
        : undefined;

/** The breakdown behind the run's label, for its tooltip, with the runner's pre-flight and its calls outside the scenarios apart. */
export const runCallsTitle = (calls?: ScenarioRunExactCalls) =>
    calls
        ? [
              `Connector: ${counted(calls.connector)}`,
              `Runner: ${counted(calls.runner)}`,
              `Runner, pre-flight: ${counted(calls.runnerPreflight)}`,
              `Runner, outside the scenarios: ${counted(
                  calls.runnerOutsideScenarios
              )}`,
          ].join('\n')
        : undefined;
